import { render } from "./CustomisationWindow.vue?vue&type=template&id=a1d8e8e8&scoped=true"
import script from "./CustomisationWindow.vue?vue&type=script&lang=js"
export * from "./CustomisationWindow.vue?vue&type=script&lang=js"

import "./CustomisationWindow.vue?vue&type=style&index=0&id=a1d8e8e8&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d8e8e8"]])

export default __exports__